import { defineStore } from "pinia";
import { useRouter } from "vue-router";

interface INavigationState {
  html: string | undefined;
  configCountry: string | undefined;
  configNationality: string | undefined;
  orgUrl: string | undefined;
  isLive: boolean | undefined;
  hideNavigation: boolean;
  adminAppUrl: string;
}

export const useNaviStore = defineStore({
  id: "navigation",
  state: (): INavigationState => ({
    html: undefined,
    orgUrl: undefined,
    configCountry: undefined,
    configNationality: undefined,
    isLive: false,
    hideNavigation: false,
    adminAppUrl: '',
  }),
  getters: {
    getHtml: (state) => {
      return () => {
        return state.html;
      };
    },
  },
  actions: {
    async getNavigationHtml() {
      const router = useRouter();
      await router.isReady();

      if (this.html) return;

      const response = await this.axiosFactory
        .withoutToken()
        .get(`/api/Navigation?url=${encodeURI(location.href)}`);
      
      if (response.data?.success) {
        this.html = response.data.data.html;
        this.orgUrl = response.data.data.orgUrl;
        this.isLive = response.data.data.isLive;
        this.configCountry = response.data.data.configCountry;
        this.configNationality = response.data.data.configNationality;
        this.adminAppUrl = response.data.data.adminAppUrl;
        if (response.data.data.configCountryCode) {
          document.body.className = `country_${String(
            response.data.data.configCountryCode
          ).toLowerCase()}`;
        }
      } else {
        console.log("Navigation API Response:", response);
      }
    },
  },
});
